<template>
  <div style="height: 100%">
    <div class="resp_table">
      <div class="header_devices">
        <h4 class="title">{{ translate('esim_profile.section.esim_history') }}</h4>
      </div>

      <TextTable
        :all_data = "all_data"
      />
    </div>
  </div>
</template>

<script>
import TextTable from 'components/UIComponents/Plugins/TextTablePlagin/TextTable.vue';

export default {
  name: 'EsimProfileHistory',
  components: {
    TextTable
  },
  props: {
    profile: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      error: false,
      all_data: {},
      limit: true
    }
  },
  computed:{
    sim_id () { return this.$route.params.esim_profile_id }
  },
  watch: {
    sim_id () {
      this.get_device_history()
    },
    profile(){
      this.get_device_history()
    }
  },
  mounted () {
    this.get_device_history()
  },
  methods: {
    get_device_history(){
      if (this.$route.name === 'esim_profile_section') {
        this.$http.simcard.getEsimProfileHistory(this.profile.id, (response) => {
          this.all_data = response.data
        })
      }
    }
  },
}
</script>
<style lang="scss" scoped>
  .resp_table{
    padding: 10px;
  }
  .header_devices{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    h4.title{
      font-size: 12px;
      line-height: 120%;
      font-weight: bold;
    }
    .switch{
      font-size: 12px;
      line-height: 120%;
    }
  }
  .link_simcard {
    cursor: pointer;
    transition: 0.2s;
    &:hover{
      background-color: #eee;
    }
  }
 </style>
